module.exports = __webpack_public_path__ + "img/travel-destination-2.6ad4dcce.svg";